import AsyncStorage from '@react-native-async-storage/async-storage'

const NS_AVATAR = 'avatarCache:'

async function getTTLItem(storageKey) {
  try {
    const raw = await AsyncStorage.getItem(storageKey)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    const { value, expiresAt } = parsed
    if (typeof expiresAt === 'number' && Date.now() > expiresAt) {
      // Expirado: limpiar y retornar null
      AsyncStorage.removeItem(storageKey).catch(() => {})
      return null
    }
    // Normalizar posibles objetos URL/ReadableNativeMap a string
    if (typeof value === 'string') return value
    if (value && typeof value === 'object') {
      try {
        const str = typeof value.href === 'string' ? value.href : (typeof value.toString === 'function' ? value.toString() : null)
        return typeof str === 'string' ? str : null
      } catch {
        return null
      }
    }
    return value ?? null
  } catch (e) {
    return null
  }
}

async function setTTLItem(storageKey, value, ttlMs) {
  try {
    const expiresAt = typeof ttlMs === 'number' && ttlMs > 0 ? Date.now() + ttlMs : undefined
    const payload = JSON.stringify({ value, expiresAt })
    await AsyncStorage.setItem(storageKey, payload)
  } catch (e) {
    // noop
  }
}

export async function getAvatarFromCache(key) {
  if (!key) return null
  const storageKey = `${NS_AVATAR}${key}`
  return getTTLItem(storageKey)
}

export async function setAvatarInCache(key, url, ttlMs = 24 * 60 * 60 * 1000) {
  if (!key || !url) return
  const storageKey = `${NS_AVATAR}${key}`
  const normalized = typeof url === 'string' ? url : (url && typeof url.toString === 'function' ? url.toString() : null)
  if (!normalized) return
  return setTTLItem(storageKey, normalized, ttlMs)
}

export async function purgeAvatarCacheForKeys(keys = []) {
  try {
    await Promise.all(
      keys
        .filter(Boolean)
        .map((k) => AsyncStorage.removeItem(`${NS_AVATAR}${k}`).catch(() => {})),
    )
  } catch (e) {
    // noop
  }
}
